<template>
  <div>
    <van-cell-group title="预算金额明细" :border="true">
    </van-cell-group>


    <van-cell-group :border="true" v-for="(item,i) in child_costs" :key="i">
      <van-row class="account_top">
        <van-col span="12">
          <span class="no">0{{i+1}}</span>
        </van-col>
        <van-col span="6"><van-button @click="addNode()"  size="normal" type="primary"  native-type="button">+ 添加</van-button></van-col>
        <van-col span="6"><van-button @click="delNode(i)" size="normal" type="danger"  native-type="button">- 删除</van-button></van-col>
        
      </van-row>
      <!-- <van-field v-model="child_costs[i].cost_center" label="成本中心" size='large' :border="true" placeholder="请选择成本中心" required @click="cost_center[i].show = true" readonly is-link :rules="[{ required: true, message: '请选择成本中心' }]"/>
      <van-action-sheet v-model="cost_center[i].show" :actions="cost_centers" @select="cost_center_onselect($event,i)" /> -->
      <van-field v-model="child_costs[i].cost_account" label="费用科目" size='large' :border="true" placeholder="请选择费用科目！" required @click="cost_account[i].show = true" readonly is-link :rules="[{ required: true, message: '请选择费用科目' }]"/>
      <van-action-sheet v-model="cost_account[i].show" :actions="cost_accounts" @select="cost_account_onselect($event,i)" />
      <van-field v-model="child_costs[i].amount"  @blur="onChangeAmount" label="预算金额" type="number" size='large' :border="true" placeholder="请输入预算金额" required :rules="[{ required: true, message: '请填写预算金额' }]"/>
      <!-- <van-row>
        <van-col span="12" style="margin:10px auto ">计划预算：{{child_costs[i].budget}}元</van-col>
        <van-col span="12" style="margin:10px auto">已用预算 {{child_costs[i].budget_used}}元</van-col>
        <van-col span="12" style="margin:10px auto">申请中预算：{{child_costs[i].budget_applying}}元</van-col>
        <van-col span="12" style="margin:10px auto">可用预算：{{child_costs[i].budget_usable}}元</van-col>
      </van-row> -->
      <!-- <van-notice-bar
        wrapable
        :scrollable="false"
        :text="notices[i]"
        v-show="notices[i]"
      /> -->

      </van-cell-group>
      <!-- <van-cell-group>
        <van-notice-bar
          wrapable
          :scrollable="false"
          v-for="item in notices"
          :key="item.id"
          :text="item.notice"
          v-show="item.notice"
        />

      </van-cell-group> -->
      <van-cell-group title="总计" :border="true">
        <van-field v-model="amount" label="预算总金额" size='large' readonly  :border="true"/>
        <van-field v-model="amount_word" label="金额大写" size='large' readonly  :border="true"/>
      </van-cell-group>
      <van-cell-group title="附件上传" :border="true">
        <div
            
            class="img_box"
            v-for="(file, index) in child_files"
            :v-if="file"
            :key="index"
          >
          <div class="upload_img" v-if="type(file) == 'image'">
            <van-image
              
              width="5rem"
              height="5rem"
              fit="contain"
              :src="'http://caiwuapi.itkeen.net/'+file"
              @click="getImg(index)"
            >
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
            </van-image>

          </div>
          <div class="upload_img" v-else-if="type(file) == 'pdf'">  
            <a :href="file"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/pdf.png"
            >
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
            </van-image></a>
          </div>
          <div class="upload_img" v-else-if="type(file) == 'excel'">  
            <a :href="file" 
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/xls.png"
            >
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
            </van-image></a>

          </div>
          <div class="upload_img" v-else-if="type(file) == 'word'">  
            <a :href="file" 
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/docx.png"
            >
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
            </van-image></a>
          </div>
          <div class="upload_img" v-else-if="type(file) == 'zip'">  
            <a :href="file" 
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/zip.png"
            /></a>
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
          </div>
          <div class="upload_img"  v-else-if="type(file) == 'rar'">  
            <a :href="file"
              ><van-image
                width="4rem"
                height="4rem"
                fit="contain"
                src="/images/filesicon/rar.png"
            >
            <van-icon name="close" @click="deleteFile(index)" class="delete"/>
            </van-image></a>
          </div>
          </div>

        
        </van-cell-group>
        <van-cell-group>
        <!-- <van-uploader style="margin:20px auto;" :after-read="uploadFile"> -->
        <van-uploader style="margin:20px auto;" multiple :after-read="uploadFiles">
          <van-button icon="plus" type="primary"  native-type="button">附件上传（支持批量）</van-button>
        </van-uploader>
      </van-cell-group>
  </div>
</template>

<script>
import {moneyToChinese} from '../../assets/js/moneyToChinese.js'
import {digit_uppercase} from '../../assets/js/digitUppercase.js'
import { ImagePreview } from "vant";
import { fileType } from "../../assets/js/fileType.js";

export default {
  name: 'Cost',
  props: {
    // parent_cost_center:Object,
    // cost_centers:Array,
    cost_accounts:Array,
    fileList:Array, 
    files:Array,//这个是上传的文件列表，需要传输到父组件
    costs:Array,

  },
  data(){
    return{
      // amount:'',
      child_costs:this.costs,
      amount_word:'',
      
    
      cost_account:[{
        show:false
      },{
        show:false
      },{
        show:false
      },{
        show:false
      },{
        show:false
      }],
      cost_center:[{
        show:false
      },{
        show:false
      },{
        show:false
      },{
        show:false
      },{
        show:false
      }],
      budgetForm:{
        center_id:'',
        account_id:'',
      },
      
      child_fileList:this.fileList,
      child_files:this.files,
      notices:['','','','','','',''],
    
      

    }
  },
  created(){
    // console.log(this.child_costs)
    // console.log(this.fileList)
    // this.child_fileList = this.fileList
    // this.child_files = this.files

  },
  methods:{
    addNode(){
      this.child_costs.push({account_id:'', cost_account:'',amount:''})
      this.cost_center.push({show:false})
      this.cost_account.push({show:false})

    },
    delNode(i){
      if(this.child_costs.length == 1){
        // this.$alert('费用归集及分摊至少保留一个！')
        // this.$dialog.alert({
        //   message: '费用归集及分摊至少保留一个！',
        // })
        this.$toast.fail('预算至少保留一个！');
        return false;
      }
      this.child_costs.splice(i,1)

    },

    cost_account_onselect(item,i){
      this.cost_account[i].show = false;
      this.child_costs[i].cost_account = item.name;
      this.child_costs[i].account_id = item.id;
      this.$emit('changeCost',this.child_costs,this.amount,this.amount_word,this.child_files)


    },
    getBudget(i){
      
      this.$http.post('getbudget',this.child_costs[i])
      .then((res)=>{
        console.log(res)
        if(res.data.code!=200){
          console.log(res.data.msg)
        }
        // this.child_costs[i].budget = res.data.data
        this.child_costs[i].budget_id = res.data.data.id;
        this.child_costs[i].budget = res.data.data.budget;
        this.child_costs[i].budget_used = res.data.data.budget_used;
        this.child_costs[i].budget_applying = res.data.data.budget_applying;
        this.child_costs[i].budget_usable = res.data.data.budget_usable;

      })
    },
    getNotice(){
      var account_ids = ''
      this.child_costs.forEach(function(e){
        account_ids += e.account_id+',';

      })
      var ids = account_ids.slice(0,account_ids.length-1);
      this.$http.post('account_notice',{'ids':ids})
      .then((res)=>{
        console.log(res)
        this.notices = res.data.data
      })


    },
    uploadFile(file){
      console.log(file)
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
　　  formData.append('file', file.file); //接口需要传的参数
      console.log(formData.get("file"))
      this.$http.post('/upload',formData)
      .then((res)=>{
        if(res.data.code != 200){
          this.$dialog.alert({
          message: res.data.msg,
          })
          return false;
        }
        // var file = {url:res.data.data.url}
        // this.fileList.push(file)
        // console.log(this.fileList)
        if(this.child_files == ''){
          this.child_files = [];

        }
        this.child_files.push(res.data.data.path)
        this.$emit('changeCost',this.child_costs,this.amount,this.amount_word,this.child_files)
        // console.log(this.child_fileList)
        // console.log(this.child_files)
      })

    },
    uploadFiles(files){
      console.log(files)
      // return false;
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
// 　　  formData.append('file', file); //接口需要传的参数
      console.log(Array.isArray(files))
      if(Array.isArray(files)){
        files.forEach( function(file){
          formData.append('file[]', file.file); //接口需要传的参数
        })
      }else{
        formData.append('file[]', files.file)
      }
      
      // console.log(formData)
      this.$http.post('/upload/files',formData)
      .then((res)=>{
        if(res.data.code != 200){
          this.$dialog.alert({
          message: res.data.msg,
          })
          return false;
        }
        // var file = {url:res.data.data.url}
        // this.fileList.push(file)
        // console.log(this.fileList)
        if(this.child_files == ''){
          this.child_files = [];

        }
        console.log(res.data.data)
        let that = this
        res.data.data.forEach(function(item){
          console.log(item)
          that.child_files.push(item)
          
        })
        console.log(this.child_files)
        // this.child_files.push(res.data.data.path)
        this.$emit('changeCost',this.child_costs,this.amount,this.amount_word,this.child_files)
        // console.log(this.child_fileList)
        // console.log(this.child_files)
      })

    },
    deleteFile(item){
      // console.log('11111')
      this.child_files.splice(item,1)
      this.$emit('changeCost', this.child_costs,this.amount,this.amount_word,this.files)

    },
    onChangeAmount(){

      this.$emit('changeCost', this.child_costs,this.amount,this.amount_word,this.files)
    },
    type(file) {
      return fileType(file);
    },
    getImg(index) {
      ImagePreview({
        images: this.child_files, // 预览图片的那个数组
        showIndex: true,
        loop: false, //循环播放
        startPosition: index, // 指明预览第几张图
        showIndicators:true,//是否显示轮播指示器
        closeable:true, //是否显示关闭图标
      });
    },
    
    
  },
  computed:{
    amount:{
      get(){
        var cost_amount = 0
        this.child_costs.forEach(function(e){
          cost_amount += Number(e.amount)
        })
        return cost_amount;

      },
      set(){

      }
      
    }

  },
  watch:{
    'amount':function(value){
      // this.amount_word = moneyToChinese(value);
      this.amount_word = digit_uppercase(value);
      
      // this.$emit('changeCost', this.child_costs,this.amount,this.amount_word,this.files)
      
      // this.$emit('changeCost', this.child_costs,this.amount,this.amount_word,this.files)
    },
    // 'costs':function(value){
    //   this.child_costs = value
    //   this.child_fileList = this.fileList
    //   this.child_files = this.files
    //   for (var index = 0; index < this.child_costs.length; index++) {
    //     this.getBudget(index)
    //   }
    //   this.$emit('changeCost', this.child_costs,this.amount,this.amount_word,this.files)
    //   console.log(this.child_costs)

    // }
    
    // 'amount':function(val){
      
    //   this.$emit('changePayInfo',this.payInfo)
    // },
  },
  // computed:{
  //   'costs[i].budget_usable':function(){
  //     return costs[i].budget - costs[i].budget_used;
  //   }

  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.account_top{
  border-left: #42b983 5px solid;
  height:45px;
  border-bottom:#eee 1px solid;
}
.account_top .no{
  margin:10px 5px;
  font-weight: bold;
  color:#42b983;
  float:left;
  padding-top:5px;

}
/* .account_top button{
  margin:10px 5px;
  color:#42b983;
  font-weight: bold;

} */
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
.van-notice-bar{
  text-align: left;
}
.img_box {
  display: inline-block;
}
.image-remove{
  /* background-color: white; */
  color: #666666;
  font-size: 30px;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 100%;
  transform: rotate(45deg); 
  cursor:pointer;
  opacity: 0.5;
  top:0px;
  right:0px;   
  display: block;
  position:absolute; 
 
}
.delete{
  top:0px;
  right:0px; 
  
  display: block;
  position:absolute; 
  font-size:28px;
}
.upload_img{
  display:inline;
  margin:15px;
}
</style>
